// extracted by mini-css-extract-plugin
export default {"self":"CartButton_self__VTZ2x","icon":"CartButton_icon__Tw81J"};